import request from '@/utils/request'

// 查询预约渠道列表
export function listChannel(query) {
    return request({
        url: '/biz/channel/list',
        method: 'get',
        params: query
    })
}

// 查询预约渠道详细
export function getChannel(id) {
    return request({
        url: '/biz/channel/' + id,
        method: 'get'
    })
}

// 新增预约渠道
export function addChannel(data) {
    return request({
        url: '/biz/channel',
        method: 'post',
        data: data
    })
}

// 修改预约渠道
export function updateChannel(data) {
    return request({
        url: '/biz/channel/update',
        method: 'post',
        data: data
    })
}

// 删除预约渠道
export function delChannel(id) {
    return request({
        url: '/biz/channel/delete/' + id,
        method: 'post'
    })
}
